import type { CarrierRepType } from "./types";

export const REP_TYPES = [
  "sales_rep",
  "mailbox",
] as const satisfies readonly CarrierRepType[];

export const REP_TYPE_LABELS: Record<CarrierRepType, string> = {
  sales_rep: "Sales rep",
  mailbox: "Mailbox",
};
